import { UPDATE_ASSET_ID } from '../constants'

export default (id: string): { type: string; id: string } => ({
    type: UPDATE_ASSET_ID,
    id
})
